export enum DateTimeFormat {
  Time24h = 'HH:mm:ss', // 13:21:50 OR 07:21:50
  Time24hShort = 'HH:mm', // 00:00
  Time12h = 'h:mm a', // 1:21 PM OR 7:21 AM
  Time12hShort = 'h a', // 1:21 PM OR 7:21 AM

  // TODO remove
  // Only Used for "Dashboard chart" when display chart ticks by hours
  // Different formats like h:mm a brakes the chart XAxis (no ticks displayed)

  DayOfWeekWithDate = 'EEEE, MMMM d', // Monday, February 15 OR Monday, February 05
  DayOfWeekWithShortMonthDate = 'EEEE, MMM d', // Monday, Feb 15 OR Monday, Feb 5

  DateDashed = 'yyyy-MM-dd', //2024-02-15 OR 2024-02-05
  Date = 'MMM dd', // Feb 15 OR Feb 05
  DateWithYear = 'MMM dd, yyyy', // Feb 15, 2024 OR Feb 05, 2024
  DateSlashed = 'M/d/yyyy', // 2/15/2024 OR 5/2/2024
  MonthAndDateSlashed = 'M/d', // 2/15 OR 5/2

  DateTime12h = 'MMM dd yyyy, h:mm a', // Feb 15 2024, 1:21 PM OR Feb 05 2024, 7:21 AM
  DateTimeFullMonth12h = 'MMMM dd, yyyy, h:mm a', // February 15, 2024, 1:21 PM OR February 05, 2024, 7:21 AM
  DateTime24h = 'MMM dd yyyy, HH:mm:ss', // Feb 15 2024, 13:21:10 OR Feb 05 2024, 07:21:55
  DateTimeSlashed12h = 'MM/dd/yyyy - h:mm a', // 08/13/2025 - 3:21 PM
  DateTimeYearFirstSlashed24h = 'yyyy/MM/dd HH:mm:ss', // 2024/08/13 15:21:10 OR 2024/08/05 07:21:55 (year-first, unlike the other *Slashed* formats above)
  DateTimeForFilter = 'MM-dd-yyyy-HH-mm', // 06-09-2025-19-45

  DateTimeISOUtc = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", // 2023-06-13T15:00:00.000Z

  Month = 'MMMM', // April

  // eslint-disable-next-line
  Default = "yyyy-MM-dd'T'HH:mm:ssxxx", // 2023-06-13T15:00:00+03:00
  // TODO remove and replace with Date.toISOString() or someting else;
  // NOTE: ISO format is braking "Audiences size" API request for chart
}

export enum DateTimeFormatParse {
  Time24hFull = 'HH:mm:ss', // 13:21:55 OR 07:21:55  PPP
  Time24h = 'HH:mm', // 13:21 OR 07:21
  DateTime24hFull = 'yyyy-MM-dd HH:mm:ss', // 2024-02-15 13:21:55 OR 2024-02-05 07:21:55
  DateTimeForFilter = 'MM-dd-yyyy-HH-mm', // 06-09-2025-19-45
  Date = 'MMM dd', // Feb 15 OR Feb 05
}

export enum DateTimeFormatTZ {
  TimeWithShortTimeZone = 'TimeWithShortTimeZone', // 'HH:mm:ss z'  |  10:44:15 EST
  Time24h = 'HH:mm:ss', // 13:21:50 OR 07:21:50
  Date = 'Date', // 'MM-dd-yy'  |  02-21-24
  DateWithSlash = 'yyyy/MM/dd', // 2024/02/15 OR 2024/02/05
  DateTimeWithShortTimeZone = 'DateTimeWithShortTimeZone', // 'yyyy/MM/dd HH:mm:ss z'  |  2000/01/31 19:50:10 EST
  TimeZoneOffset = 'TimeZoneOffset', // 'XXX'  |  -05:00 (timezone offset)
  ShortTimeZone = 'ShortTimeZone', // 'z'  |  EST (Short timezone code)
  DateTimeSlashed12hWithShortTimeZone = 'DateTimeSlashed12hWithShortTimeZone', // 'z'  |  EST (Short timezone code)
  ShortTimeZoneWithOffset = 'ShortTimeZoneWithOffset', // "z '(GMT' xxx)"  |  GMT-5 (GMT -05:00)
}
